<template>
  <v-flex
    id="reflectionBarriers"
    class="question"
  >
    <p class="mb-0 text-uppercase">
      {{ $t('sheet.sheetOne.reflection.hint') }}
    </p>
    <h2 class="display-3 display-3_dark mb-4">
      {{ getBarriersQuestions.label }}
    </h2>
    <div class="content">
      <div class="alert-box pa-3">
        <p class="mb-0">
          {{ $t('sheet.sheetOne.reflection.barriers.info') }}
        </p>
      </div>
    </div>
    <ol class="questions-list">
      <li
        v-if="getBarriersQuestions.hasOwnProperty('competence')"
        class="mt-4"
      >
        <p
          class="header"
          :class="{ required: getBarriersQuestions.competence.required }"
        >
          {{ $t('sheet.sheetOne.reflection.barriers.question_1') }}
        </p>
        <p class="fw-600 f-1">
          {{ getBarriersQuestions.competence.label }}
        </p>
        <v-checkbox
          v-for="(item, index) in competenceBarriers.items"
          :key="index"
          v-model="competence"
          v-validate="{ rules: { required: isBarriersRequired } }"
          multiple
          :label="item.description"
          :value="item.id"
          :data-vv-as="$t('sheet.sheetOne.reflection.barriers.title')"
          data-vv-name="barriers"
          :required="isBarriersRequired"
          :disabled="readOnly"
        />
        <div
          v-if="competenceBarriers.showOtherCompetenceBarriers"
          class="mt-4"
        >
          <p
            class="fw-600 mb-0"
            :class="{ required: getBarriersQuestions.competence_other_text.required }"
          >
            {{ getBarriersQuestions.competence_other_text.label }}
          </p>
          <v-text-field
            v-model="competenceOtherText"
            v-validate="{ ...regularLongText(getBarriersQuestions.competence_other_text.required) }"
            :placeholder="$t('placeholders.add_text')"
            :error-messages="errors.collect('reflection_barriers')"
            :data-vv-as="$t('label.question')"
            data-vv-name="reflection_barriers"
            :required="getBarriersQuestions.competence_other_text.required"
            :disabled="readOnly"
          />
        </div>
        <div>
          <p class="fw-600 f-1 mt-4">
            {{ getBarriersQuestions.beliefs.label }}
          </p>
          <v-checkbox
            v-for="(item, index) in beliefsBarriers.items"
            :key="index"
            v-model="beliefs"
            v-validate="{ rules: { required: isBarriersRequired } }"
            multiple
            :label="item.description"
            :value="item.id"
            :data-vv-as="$t('sheet.sheetOne.reflection.barriers.title')"
            data-vv-name="barriers"
            :required="isBarriersRequired"
            :disabled="readOnly"
          />
          <div
            v-if="beliefsBarriers.showOtherBeliefsBarriers"
            class="mt-4"
          >
            <p
              class="fw-600 mb-0"
              :class="{ required: getBarriersQuestions.beliefs_other_text.required }"
            >
              {{ getBarriersQuestions.beliefs_other_text.label }}
            </p>
            <v-text-field
              v-model="beliefsOtherText"
              v-validate="{ ...regularLongText(getBarriersQuestions.beliefs_other_text.required) }"
              :placeholder="$t('placeholders.add_text')"
              :error-messages="errors.collect('reflection_barriers_2')"
              :data-vv-as="$t('label.question')"
              data-vv-name="reflection_barriers_2"
              :required="getBarriersQuestions.beliefs_other_text.required"
              :disabled="readOnly"
            />
          </div>
        </div>
        <div>
          <p class="fw-600 f-1 mt-4">
            {{ getBarriersQuestions.condition.label }}
          </p>
          <v-checkbox
            v-for="(item, index) in conditionBarriers.items"
            :key="index"
            v-model="condition"
            v-validate="{ rules: { required: isBarriersRequired } }"
            multiple
            :label="item.description"
            :value="item.id"
            :data-vv-as="$t('sheet.sheetOne.reflection.barriers.title')"
            data-vv-name="barriers"
            :required="isBarriersRequired"
            :disabled="readOnly"
          />
          <div
            v-if="conditionBarriers.showOtherConditionBarriers"
            class="mt-4"
          >
            <p
              class="fw-600 mb-0"
              :class="{ required: getBarriersQuestions.condition_other_text.required }"
            >
              {{ getBarriersQuestions.condition_other_text.label }}
            </p>
            <v-text-field
              v-model="conditionOtherText"
              v-validate="{
                ...regularLongText(getBarriersQuestions.condition_other_text.required)
              }"
              :placeholder="$t('placeholders.add_text')"
              :error-messages="errors.collect('reflection_barriers_3')"
              :data-vv-as="$t('label.question')"
              data-vv-name="reflection_barriers_3"
              :required="getBarriersQuestions.condition_other_text.required"
              :disabled="readOnly"
            />
          </div>
        </div>
        <div>
          <p class="fw-600 f-1 mt-4">
            {{ getBarriersQuestions.support.label }}
          </p>
          <v-checkbox
            v-for="(item, index) in supportBarriers.items"
            :key="index"
            v-model="support"
            v-validate="{ rules: { required: isBarriersRequired } }"
            multiple
            :label="item.description"
            :value="item.id"
            :data-vv-as="$t('sheet.sheetOne.reflection.barriers.title')"
            data-vv-name="barriers"
            :required="isBarriersRequired"
            :disabled="readOnly"
          />
          <div
            v-if="supportBarriers.showOtherSupportBarriers"
            class="mt-4"
          >
            <p
              class="fw-600 mb-0"
              :class="{ required: getBarriersQuestions.support_other_text.required }"
            >
              {{ getBarriersQuestions.support_other_text.label }}
            </p>
            <v-text-field
              v-model="supportOtherText"
              v-validate="{ ...regularLongText(getBarriersQuestions.support_other_text.required) }"
              :placeholder="$t('placeholders.add_text')"
              :error-messages="errors.collect('reflection_barriers_4')"
              :data-vv-as="$t('label.question')"
              data-vv-name="reflection_barriers_4"
              :required="getBarriersQuestions.support_other_text.required"
              :disabled="readOnly"
            />
          </div>
        </div>
        <div
          v-if="errors.has('barriers')"
          class="v-message my-4 text-xs-center"
        >
          <div class="v-messages__message">
            {{ errors.first('barriers') }}
          </div>
        </div>
      </li>
      <li
        v-if="showQuestions && getBarriersQuestions.hasOwnProperty('important')"
        class="mt-4"
      >
        <p
          class="header custom lA"
          :class="{ required: getBarriersQuestions.important.required }"
        >
          {{ getBarriersQuestions.important.label }}
        </p>
        <div v-if="competence.length > 0">
          <p class="fw-600 f-1">
            {{ $t('sheet.sheetOne.reflection.barriers.competence_barriers_title') }}
          </p>
          <v-checkbox
            v-for="(item, index) in competence"
            :key="index"
            v-model="importantCompetence"
            v-validate="{ rules: { required: isImportantBarriersRequired } }"
            multiple
            :label="createLabel(item, 1)"
            :value="item"
            :data-vv-as="$t('sheet.sheetOne.reflection.barriers.important_barriers')"
            data-vv-name="importantBarriers"
            :required="isImportantBarriersRequired"
            :disabled="readOnly"
          />
        </div>
        <div
          v-if="beliefs.length > 0"
          class="mt-4"
        >
          <p class="fw-600 f-1">
            {{ $t('sheet.sheetOne.reflection.barriers.beliefs_barriers_title') }}
          </p>
          <v-checkbox
            v-for="(item, index) in beliefs"
            :key="index"
            v-model="importantBeliefs"
            v-validate="{ rules: { required: isImportantBarriersRequired } }"
            multiple
            :label="createLabel(item, 2)"
            :value="item"
            :data-vv-as="$t('sheet.sheetOne.reflection.barriers.important_barriers')"
            data-vv-name="importantBarriers"
            :required="isImportantBarriersRequired"
            :disabled="readOnly"
          />
        </div>
        <div
          v-if="condition.length > 0"
          class="mt-4"
        >
          <p class="fw-600 f-1">
            {{ $t('sheet.sheetOne.reflection.barriers.conditions_barriers_title') }}
          </p>
          <v-checkbox
            v-for="(item, index) in condition"
            :key="index"
            v-model="importantCondition"
            v-validate="{ rules: { required: isImportantBarriersRequired } }"
            multiple
            :label="createLabel(item, 3)"
            :value="item"
            :data-vv-as="$t('sheet.sheetOne.reflection.barriers.important_barriers')"
            data-vv-name="importantBarriers"
            :required="isImportantBarriersRequired"
            :disabled="readOnly"
          />
        </div>
        <div
          v-if="support.length > 0"
          class="mt-4"
        >
          <p class="fw-600 f-1">
            {{ $t('sheet.sheetOne.reflection.barriers.support_barriers_title') }}
          </p>
          <v-checkbox
            v-for="(item, index) in support"
            :key="index"
            v-model="importantSupport"
            v-validate="{ rules: { required: isImportantBarriersRequired } }"
            multiple
            :label="createLabel(item, 4)"
            :value="item"
            :data-vv-as="$t('sheet.sheetOne.reflection.barriers.important_barriers')"
            data-vv-name="importantBarriers"
            :required="isImportantBarriersRequired"
            :disabled="readOnly"
          />
        </div>
        <div
          v-if="errors.has('importantBarriers')"
          class="v-message my-4 text-xs-center"
        >
          <div class="v-messages__message">
            {{ errors.first('importantBarriers') }}
          </div>
        </div>
      </li>
      <li
        v-if="showQuestions && getBarriersQuestions.hasOwnProperty('break')"
        class="mt-4"
      >
        <p
          class="header custom lB"
          :class="{ required: getBarriersQuestions.break.required }"
        >
          {{ getBarriersQuestions.break.label }}
        </p>
        <div v-if="competence.length > 0">
          <p class="fw-600 f-1">
            {{ $t('sheet.sheetOne.reflection.barriers.competence_barriers_title') }}
          </p>
          <v-checkbox
            v-for="(item, index) in competence"
            :key="index"
            v-model="breakCompetence"
            v-validate="{ rules: { required: isBreakBarriersRequired } }"
            multiple
            :label="createLabel(item, 1)"
            :value="item"
            :data-vv-as="$t('sheet.sheetOne.reflection.barriers.break_barriers')"
            data-vv-name="breakBarriers"
            :required="isBreakBarriersRequired"
            :disabled="readOnly"
            @click.native="checkAllBarriers()"
          />
        </div>
        <div
          v-if="beliefs.length > 0"
          class="mt-4"
        >
          <p class="fw-600 f-1">
            {{ $t('sheet.sheetOne.reflection.barriers.beliefs_barriers_title') }}
          </p>
          <v-checkbox
            v-for="(item, index) in beliefs"
            :key="index"
            v-model="breakBeliefs"
            v-validate="{ rules: { required: isBreakBarriersRequired } }"
            multiple
            :label="createLabel(item, 2)"
            :value="item"
            :data-vv-as="$t('sheet.sheetOne.reflection.barriers.break_barriers')"
            data-vv-name="breakBarriers"
            :required="isBreakBarriersRequired"
            :disabled="readOnly"
            @click.native="checkAllBarriers()"
          />
        </div>
        <div
          v-if="condition.length > 0"
          class="mt-4"
        >
          <p class="fw-600 f-1">
            {{ $t('sheet.sheetOne.reflection.barriers.conditions_barriers_title') }}
          </p>
          <v-checkbox
            v-for="(item, index) in condition"
            :key="index"
            v-model="breakCondition"
            v-validate="{ rules: { required: isBreakBarriersRequired } }"
            multiple
            :label="createLabel(item, 3)"
            :value="item"
            :data-vv-as="$t('sheet.sheetOne.reflection.barriers.break_barriers')"
            data-vv-name="breakBarriers"
            :required="isBreakBarriersRequired"
            :disabled="readOnly"
            @click.native="checkAllBarriers()"
          />
        </div>
        <div
          v-if="support.length > 0"
          class="mt-4"
        >
          <p class="fw-600 f-1">
            {{ $t('sheet.sheetOne.reflection.barriers.support_barriers_title') }}
          </p>
          <v-checkbox
            v-for="(item, index) in support"
            :key="index"
            v-model="breakSupport"
            v-validate="{ rules: { required: isBreakBarriersRequired } }"
            multiple
            :label="createLabel(item, 4)"
            :value="item"
            :data-vv-as="$t('sheet.sheetOne.reflection.barriers.break_barriers')"
            data-vv-name="breakBarriers"
            :required="isBreakBarriersRequired"
            :disabled="readOnly"
            @click.native="checkAllBarriers()"
          />
        </div>
        <v-checkbox
          v-model="cantBreakBarriers"
          v-validate="{ rules: { required: isBreakBarriersRequired } }"
          class="mt-5 text-dark f-1"
          :label="$t('sheet.sheetOne.reflection.barriers.cant_break_barriers')"
          :data-vv-as="$t('sheet.sheetOne.reflection.barriers.break_barriers')"
          data-vv-name="breakBarriers"
          :required="isBreakBarriersRequired"
          :false-value="null"
          :true-value="true"
          :disabled="readOnly"
        />
        <div
          v-if="errors.has('breakBarriers')"
          class="v-message my-4 text-xs-center"
        >
          <div class="v-messages__message">
            {{ errors.first('breakBarriers') }}
          </div>
        </div>
      </li>
      <li
        v-if="showHasInfluence && getBarriersQuestions.hasOwnProperty('has_influence')"
        class="mt-4"
      >
        <p
          class="header"
          :class="{ required: getBarriersQuestions.has_influence.required }"
        >
          {{ getBarriersQuestions.has_influence.label }}
        </p>
        <ConfirmButtons
          v-model="hasInfluence"
          v-validate="{ required: getBarriersQuestions.has_influence.required }"
          string
          :error-messages="errors.collect('hasInfluence')"
          data-vv-name="hasInfluence"
          :data-vv-as="$t('label.question')"
          :disabled="readOnly"
        />
      </li>
      <li
        v-if="
          getBarriersQuestions.hasOwnProperty('influenced') &&
            showHasInfluence &&
            hasInfluence === 'yes' &&
            showQuestions
        "
        class="mt-4"
      >
        <p
          class="header custom lA"
          :class="{ required: getBarriersQuestions.influenced.required }"
        >
          {{ getBarriersQuestions.influenced.label }}
        </p>
        <div v-if="influencedCompetenceItems.length > 0">
          <p class="fw-600 f-1">
            {{ $t('sheet.sheetOne.reflection.barriers.competence_barriers_title') }}
          </p>
          <v-checkbox
            v-for="(item, index) in influencedCompetenceItems"
            :key="index"
            v-model="influencedCompetence"
            v-validate="{ rules: { required: isInfluencedRequired } }"
            multiple
            :label="createLabel(item, 1)"
            :value="item"
            :data-vv-as="$t('sheet.sheetOne.reflection.barriers.question_4a')"
            data-vv-name="influencedBarriers"
            :required="isInfluencedRequired"
            :disabled="readOnly"
          />
        </div>
        <div
          v-if="influencedBeliefsItems.length > 0"
          class="mt-4"
        >
          <p class="fw-600 f-1">
            {{ $t('sheet.sheetOne.reflection.barriers.beliefs_barriers_title') }}
          </p>
          <v-checkbox
            v-for="(item, index) in influencedBeliefsItems"
            :key="index"
            v-model="influencedBeliefs"
            v-validate="{ rules: { required: isInfluencedRequired } }"
            multiple
            :label="createLabel(item, 2)"
            :value="item"
            :data-vv-as="$t('sheet.sheetOne.reflection.barriers.question_4a')"
            data-vv-name="influencedBarriers"
            :required="isInfluencedRequired"
            :disabled="readOnly"
          />
        </div>
        <div
          v-if="influencedConditionItems.length > 0"
          class="mt-4"
        >
          <p class="fw-600 f-1">
            {{ $t('sheet.sheetOne.reflection.barriers.conditions_barriers_title') }}
          </p>
          <v-checkbox
            v-for="(item, index) in influencedConditionItems"
            :key="index"
            v-model="influencedCondition"
            v-validate="{ rules: { required: isInfluencedRequired } }"
            multiple
            :label="createLabel(item, 3)"
            :value="item"
            :data-vv-as="$t('sheet.sheetOne.reflection.barriers.question_4a')"
            data-vv-name="influencedBarriers"
            :required="isInfluencedRequired"
            :disabled="readOnly"
          />
        </div>
        <div
          v-if="influencedSupportItems.length > 0"
          class="mt-4"
        >
          <p class="fw-600 f-1">
            {{ $t('sheet.sheetOne.reflection.barriers.support_barriers_title') }}
          </p>
          <v-checkbox
            v-for="(item, index) in influencedSupportItems"
            :key="index"
            v-model="influencedSupport"
            v-validate="{ rules: { required: isInfluencedRequired } }"
            multiple
            :label="createLabel(item, 4)"
            :value="item"
            :data-vv-as="$t('sheet.sheetOne.reflection.barriers.question_4a')"
            data-vv-name="influencedBarriers"
            :required="isInfluencedRequired"
            :disabled="readOnly"
          />
        </div>
        <div
          v-if="errors.has('influencedBarriers')"
          class="v-message my-4 text-xs-center"
        >
          <div class="v-messages__message">
            {{ errors.first('influencedBarriers') }}
          </div>
        </div>
      </li>
      <!-- 2023 Barriers -->
      <SheetQuestion
        v-if="getBarriersQuestions.hasOwnProperty('barriers_in_family')"
        :label="getBarriersQuestions.barriers_in_family.label"
        :required="getBarriersQuestions.barriers_in_family.required"
      >
        <v-checkbox
          v-for="(item, index) in barriersInFamilyResources"
          :key="index"
          v-model="barriersInFamily"
          v-validate="{ required: getBarriersQuestions.barriers_in_family.required }"
          :disabled="readOnly"
          :label="item.description"
          :value="item.id"
          type="checkbox"
          multiple
          :error="errors.has('barriersInFamily')"
          :error-messages="errors.collect('barriersInFamily')"
          :data-vv-as="$t('label.question')"
          :data-vv-name="'barriersInFamily'"
        />
        <div
          v-if="
            isOtherBarrierSelected &&
              getBarriersQuestions?.barriers_in_family.hasOwnProperty('barriers_in_family_other')
          "
        >
          <p
            class="mt-4"
            :class="{
              required: getBarriersQuestions.barriers_in_family.barriers_in_family_other.required
            }"
          >
            {{ getBarriersQuestions.barriers_in_family.barriers_in_family_other.label }}
          </p>
          <v-textarea
            v-model="barriersInFamilyOther"
            v-validate="
              regularLongText(
                getBarriersQuestions.barriers_in_family.barriers_in_family_other.required
              )
            "
            :placeholder="$t('placeholders.add_text')"
            :error-messages="errors.collect('barriersInFamilyOther')"
            data-vv-as=" "
            data-vv-name="barriersInFamilyOther"
            :required="getBarriersQuestions.barriers_in_family.barriers_in_family_other.required"
            :disabled="readOnly"
            class="mb-4"
            small
            auto-grow
          />
        </div>
      </SheetQuestion>
    </ol>
  </v-flex>
</template>

<script>
import validationRules from '@/constants/validationRules';

import ConfirmButtons from '@/components/widgets/sheet/ConfirmButtons';

import isEmpty from 'lodash.isempty';

import { createHelpers } from 'vuex-map-fields';
import { mapGetters } from 'vuex';

import sheetValidationRules from '@/mixins/sheet/sheetValidationRules';
import sheetResourcesGetter from '@/mixins/sheet/sheetResourcesGetter';
import SheetQuestion from '@/components/sheet/SheetQuestion.vue';

const { mapFields } = createHelpers({
    getterType: 'sheet/getReflectionBarriersField',
    mutationType: 'sheet/updateReflectionBarriersField'
});

export default {
    name: 'ReflectionBarriers',
    components: {
        ConfirmButtons,
        SheetQuestion
    },
    mixins: [sheetValidationRules, sheetResourcesGetter],
    inject: ['$validator'],
    props: {
        readOnly: {
            default: false,
            type: Boolean
        }
    },
    data () {
        return {
            validationRules,
            competenceBarriers: {
                items: [],
                showOtherCompetenceBarriers: false
            },
            beliefsBarriers: {
                items: [],
                showOtherBeliefsBarriers: false
            },
            conditionBarriers: {
                items: [],
                showOtherConditionBarriers: false
            },
            supportBarriers: {
                items: [],
                showOtherSupportBarriers: false
            },
            showHasInfluence: true,
            showQuestions: false
        };
    },
    computed: {
        ...mapFields([
            'competence',
            'beliefs',
            'condition',
            'support',
            'competenceOtherText',
            'beliefsOtherText',
            'conditionOtherText',
            'supportOtherText',
            'importantCompetence',
            'importantBeliefs',
            'importantCondition',
            'importantSupport',
            'breakCompetence',
            'breakBeliefs',
            'breakCondition',
            'breakSupport',
            'influencedCompetence',
            'influencedBeliefs',
            'influencedCondition',
            'influencedSupport',
            'hasInfluence',
            'cantBreakBarriers',
            'barriersInFamily',
            'barriersInFamilyOther'
        ]),
        ...mapGetters('sheet', ['getBarriersQuestions']),
        isBarriersRequired () {
            return (
                isEmpty(this.competence) &&
        isEmpty(this.beliefs) &&
        isEmpty(this.condition) &&
        isEmpty(this.support)
            );
        },
        isImportantBarriersRequired () {
            return (
                isEmpty(this.importantCompetence) &&
        isEmpty(this.importantBeliefs) &&
        isEmpty(this.importantCondition) &&
        isEmpty(this.importantSupport)
            );
        },
        isBreakBarriersRequired () {
            return (
                isEmpty(this.breakCompetence) &&
        isEmpty(this.breakBeliefs) &&
        isEmpty(this.breakCondition) &&
        isEmpty(this.breakSupport) &&
        !this.cantBreakBarriers
            );
        },
        isInfluencedRequired () {
            return (
                isEmpty(this.influencedCompetence) &&
        isEmpty(this.influencedBeliefs) &&
        isEmpty(this.influencedCondition) &&
        isEmpty(this.influencedSupport)
            );
        },
        influencedCompetenceItems () {
            const _arr = [];
            this.competence.forEach((el) => {
                if (!this.breakCompetence.includes(el)) {
                    _arr.push(el);
                }
            });
            return _arr;
        },
        influencedBeliefsItems () {
            const _arr = [];
            this.beliefs.forEach((el) => {
                if (!this.breakBeliefs.includes(el)) {
                    _arr.push(el);
                }
            });
            return _arr;
        },
        influencedConditionItems () {
            const _arr = [];
            this.condition.forEach((el) => {
                if (!this.breakCondition.includes(el)) {
                    _arr.push(el);
                }
            });
            return _arr;
        },
        influencedSupportItems () {
            const _arr = [];
            this.support.forEach((el) => {
                if (!this.breakSupport.includes(el)) {
                    _arr.push(el);
                }
            });
            return _arr;
        },
        barriersInFamilyResources () {
            return this.getResources(this.getBarriersQuestions?.barriers_in_family) ?? [];
        },
        isOtherBarrierSelected () {
            return !!this.barriersInFamily?.includes(659);
        }
    },
    watch: {
        isOtherBarrierSelected (value) {
            if (!value) this.barriersInFamilyOther = null;
        },
        competence: {
            handler (newValue, oldValue) {
                this.competenceBarriers.showOtherCompetenceBarriers = this.competence.includes(150);
                this.toggleQuestion();
                this.$nextTick(() => {
                    if (newValue != null && oldValue != null && newValue.length < oldValue.length) {
                        this.breakCompetence = this.breakCompetence.filter((el) => {
                            return newValue.includes(el);
                        });
                        this.importantCompetence = this.importantCompetence.filter((el) => {
                            return newValue.includes(el);
                        });
                        this.influencedCompetence = this.influencedCompetence.filter((el) => {
                            return newValue.includes(el);
                        });
                    }
                });
                if (newValue != null && oldValue != null) {
                    this.checkAllBarriers();
                }
            },
            immediate: true
        },
        beliefs: {
            handler (newValue, oldValue) {
                this.beliefsBarriers.showOtherBeliefsBarriers = this.beliefs.includes(156);
                this.toggleQuestion();
                this.$nextTick(() => {
                    if (newValue != null && oldValue != null && newValue.length < oldValue.length) {
                        this.breakBeliefs = this.breakBeliefs.filter((el) => {
                            return newValue.includes(el);
                        });
                        this.importantBeliefs = this.importantBeliefs.filter((el) => {
                            return newValue.includes(el);
                        });
                        this.influencedBeliefs = this.influencedBeliefs.filter((el) => {
                            return newValue.includes(el);
                        });
                    }
                });
                if (newValue != null && oldValue != null) {
                    this.checkAllBarriers();
                }
            },
            immediate: true
        },
        condition: {
            handler (newValue, oldValue) {
                this.conditionBarriers.showOtherConditionBarriers = this.condition.includes(161);
                this.toggleQuestion();
                this.$nextTick(() => {
                    if (newValue != null && oldValue != null && newValue.length < oldValue.length) {
                        this.breakCondition = this.breakCondition.filter((el) => {
                            return newValue.includes(el);
                        });
                        this.importantCondition = this.importantCondition.filter((el) => {
                            return newValue.includes(el);
                        });
                        this.influencedCondition = this.influencedCondition.filter((el) => {
                            return newValue.includes(el);
                        });
                    }
                });
                if (newValue != null && oldValue != null) {
                    this.checkAllBarriers();
                }
            },
            immediate: true
        },
        support: {
            handler (newValue, oldValue) {
                this.supportBarriers.showOtherSupportBarriers = this.support.includes(169);
                this.toggleQuestion();
                this.$nextTick(() => {
                    if (newValue != null && oldValue != null && newValue.length < oldValue.length) {
                        this.breakSupport = this.breakSupport.filter((el) => {
                            return newValue.includes(el);
                        });
                        this.importantSupport = this.importantSupport.filter((el) => {
                            return newValue.includes(el);
                        });
                        this.influencedSupport = this.influencedSupport.filter((el) => {
                            return newValue.includes(el);
                        });
                    }
                });
                if (newValue != null && oldValue != null) {
                    this.checkAllBarriers();
                }
            },
            immediate: true
        },
        cantBreakBarriers: {
            handler (val) {
                if (val === true) {
                    this.showHasInfluence = false;
                } else {
                    this.checkAllBarriers();
                }
                if (val) {
                    this.breakCompetence = [];
                    this.breakBeliefs = [];
                    this.breakCondition = [];
                    this.breakSupport = [];
                }
            },
            immediate: true
        },
        breakCompetence (val, old) {
            if (val && val.length > 0) {
                this.cantBreakBarriers = false;
            }
            if (old.length < val.length) {
                this.$nextTick(() => {
                    this.influencedCompetence = this.influencedCompetence.filter((el) => {
                        return !val.includes(el);
                    });
                });
            }
        },
        breakBeliefs (val, old) {
            if (val && val.length > 0) {
                this.cantBreakBarriers = false;
            }
            if (old.length < val.length) {
                this.$nextTick(() => {
                    this.influencedBeliefs = this.influencedBeliefs.filter((el) => {
                        return !val.includes(el);
                    });
                });
            }
        },
        breakCondition (val, old) {
            if (val && val.length > 0) {
                this.cantBreakBarriers = false;
            }
            if (old.length < val.length) {
                this.$nextTick(() => {
                    this.influencedCondition = this.influencedCondition.filter((el) => {
                        return !val.includes(el);
                    });
                });
            }
        },
        breakSupport (val, old) {
            if (val && val.length > 0) {
                this.cantBreakBarriers = false;
            }
            if (old.length < val.length) {
                this.$nextTick(() => {
                    this.influencedSupport = this.influencedSupport.filter((el) => {
                        return !val.includes(el);
                    });
                });
            }
        },
        'competenceBarriers.showOtherCompetenceBarriers' (val) {
            if (val === false) {
                this.competenceOtherText = null;
            }
        },
        'beliefsBarriers.showOtherBeliefsBarriers' (val) {
            if (val === false) {
                this.beliefsOtherText = null;
            }
        },
        'conditionBarriers.showOtherConditionBarriers' (val) {
            if (val === false) {
                this.conditionOtherText = null;
            }
        },
        'supportBarriers.showOtherSupportBarriers' (val) {
            if (val === false) {
                this.supportOtherText = null;
            }
        },
        hasInfluence (val) {
            if (val === 'no' || val == null) {
                this.$nextTick(() => {
                    this.influencedCompetence = [];
                    this.influencedBeliefs = [];
                    this.influencedCondition = [];
                    this.influencedSupport = [];
                });
            }
        },
        showHasInfluence (val) {
            if (val === false) {
                this.hasInfluence = null;
            }
        }
    },
    created () {
        this.competenceBarriers.items = this.getResources(this.getBarriersQuestions.competence);
        this.beliefsBarriers.items = this.getResources(this.getBarriersQuestions.beliefs);
        this.conditionBarriers.items = this.getResources(this.getBarriersQuestions.condition);
        this.supportBarriers.items = this.getResources(this.getBarriersQuestions.support);
    },
    methods: {
        createLabel (item, id) {
            if (item === 150 || item === 156 || item === 161 || item === 169) {
                switch (id) {
                case 1:
                    return this.competenceOtherText;
                case 2:
                    return this.beliefsOtherText;
                case 3:
                    return this.conditionOtherText;
                case 4:
                    return this.supportOtherText;
                }
            } else {
                switch (id) {
                case 1:
                    return this.competenceBarriers.items.find((el) => el.id === item).description;
                case 2:
                    return this.beliefsBarriers.items.find((el) => el.id === item).description;
                case 3:
                    return this.conditionBarriers.items.find((el) => el.id === item).description;
                case 4:
                    return this.supportBarriers.items.find((el) => el.id === item).description;
                }
            }
        },
        checkAllBarriers () {
            if (
                this.breakCompetence.length >= this.competence.length &&
        this.breakBeliefs.length >= this.beliefs.length &&
        this.breakCondition.length >= this.condition.length &&
        this.breakSupport.length >= this.support.length
            ) {
                this.showHasInfluence = false;
            } else {
                this.showHasInfluence = true;
            }
        },
        toggleQuestion () {
            this.showQuestions =
        this.competence.length > 0 ||
        this.beliefs.length > 0 ||
        this.condition.length > 0 ||
        this.support.length > 0;
        }
    }
};
</script>

<style scoped></style>
